import type { InputProps } from '../input';

import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { SearchIcon } from '@paid-ui/icons/search';

import { Input } from '../input';

export type SearchInputProps = Omit<InputProps, 'type' | 'prefix' | 'transparentPrefix'>;

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ disabled, className, inputClassName, ...restProps }, ref) => {
    return (
      <Input
        ref={ref}
        {...restProps}
        type="search"
        prefix={<SearchIcon />}
        disabled={disabled}
        transparentPrefix
        className={twMerge(
          'rounded-full border-grey-mid bg-white hover:bg-grey-light',
          disabled ? 'cursor-not-allowed bg-grey-hover hover:bg-grey-hover' : '',
          className,
        )}
        inputClassName={twMerge('bg-transparent', inputClassName)}
      />
    );
  },
);

SearchInput.displayName = 'SearchInput';
